import { render, staticRenderFns } from "./EmployeesDeclarationListComponent.vue?vue&type=template&id=595098c1&"
import script from "./EmployeesDeclarationListComponent.vue?vue&type=script&lang=js&"
export * from "./EmployeesDeclarationListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports